export default "__VITE_ASSET__CiYqXk4B__"